import React from 'react';
import { Link } from 'react-router-dom';
import { toneHex } from '../../../utils/coachLanguage';

// Simple line sparkline. Reuses tone palette.
const SparklineCard = ({ data }) => {
  const values = data?.values || [];
  const tone = data?.tone || 'primary';
  const label = data?.label || 'Trend';
  const w = 260, h = 60;
  if (!values.length) {
    return (
      <div className="rounded-sm border border-zinc-700 bg-zinc-900/40 p-4 text-xs text-zinc-500" data-testid="card-sparkline-empty">
        {label} — not enough data yet
      </div>
    );
  }
  const min = Math.min(...values), max = Math.max(...values);
  const range = max - min || 1;
  const step = values.length > 1 ? w / (values.length - 1) : 0;
  const pts = values.map((v, i) => `${(i * step).toFixed(1)},${(h - ((v - min) / range) * h).toFixed(1)}`).join(' ');
  const color = toneHex(tone);
  return (
    <Link to="/performance" className="block rounded-sm border border-zinc-700 bg-zinc-900/40 p-4 hover:border-primary transition-colors" data-testid="card-sparkline">
      <p className="text-[10px] text-zinc-500 uppercase tracking-wider mb-2">{label}</p>
      <svg width="100%" height={h} viewBox={`0 0 ${w} ${h}`} className="block">
        <polyline fill="none" stroke={color} strokeWidth="2" points={pts} />
      </svg>
      <div className="flex items-center justify-between mt-2 text-[10px] text-zinc-500">
        <span>Range {Math.round(min)} – {Math.round(max)}</span>
        <span className="text-primary">See Performance →</span>
      </div>
    </Link>
  );
};

export default SparklineCard;
